"use client"

import { Head } from "@inertiajs/react"

import AppearanceTabs from "@/components/appearance-tabs"
import { SectionHeader } from "@/components/ui/section-header"
import SettingsLayout from "@/layouts/settings/layout"

export default function Appearance() {
  return (
    <SettingsLayout>
      <Head title="Appearance settings" />
      <div className="flex flex-col gap-6 px-4 lg:px-8">
        <SectionHeader.Root>
          <SectionHeader.Group>
            <div className="flex flex-1 flex-col justify-center gap-0.5 self-stretch">
              <SectionHeader.Heading>Appearance</SectionHeader.Heading>
              <SectionHeader.Subheading>
                Update your account&apos;s appearance settings.
              </SectionHeader.Subheading>
            </div>
          </SectionHeader.Group>
        </SectionHeader.Root>

        <AppearanceTabs />
      </div>
    </SettingsLayout>
  )
}
